{
	"header": {
		"tag": "Tilisi",
		"title": "Omat ilmoitukset",
		"listDisc": "Listaa kiekko"
	},
	"empty": {
		"title": "Ei ilmoituksia vielä",
		"description": "Listaa kiekko ja se ilmestyy tähän hallittavaksi."
	},
	"sections": {
		"active": "Aktiiviset",
		"inactive": "Ei aktiiviset"
	},
	"selectAll": "Valitse kaikki",
	"select": "Valitse",
	"cancel": "Peruuta",
	"actions": {
		"markAsSold": "Merkitse myydyksi",
		"deactivate": "Poista käytöstä",
		"reactivate": "Aktivoi uudelleen",
		"edit": "Muokkaa"
	},
	"status": {
		"sold": "Myyty",
		"inactive": "Ei aktiivinen"
	},
	"negotiable": "neuvot.",
	"bulk": {
		"deactivate": "Poista käytöstä valitut ({{count}})",
		"markAsSold": "Merkitse myydyksi ({{count}})",
		"reactivate": "Aktivoi uudelleen valitut ({{count}})",
		"confirmTitle_one": "Merkitäänkö {{count}} ilmoitus myydyksi?",
		"confirmTitle_other": "Merkitäänkö {{count}} ilmoitusta myydyksi?",
		"confirmNote": "Tätä ei voi kumota.",
		"cancel": "Peruuta"
	}
}
